import { UrgencyMessage } from "../../types";
import { VinoDataOffer } from "../../types/vino-data-types";
import { isFlagEnabled } from "../../utils/is-flag-enabled";

export const urgencyMessageFromVinoDataOffer = (
  { displayFlags }: VinoDataOffer,
  isSoldOut: boolean
): UrgencyMessage | undefined => {
  const displayFlagsArray = displayFlags || [];

  if (isSoldOut) {
    return {
      status: "SOLD_OUT",
      description: "Sold out!",
      backgroundColor: "alto",
    };
  }

  if (isFlagEnabled(displayFlagsArray, "ALMOST_GONE")) {
    return {
      status: "ALMOST_GONE",
      description: "Going, going…",
      backgroundColor: "clockwork",
    };
  }

  if (isFlagEnabled(displayFlagsArray, "SELLING_FAST")) {
    return {
      status: "SELLING_FAST",
      description: "Selling crazy fast!",
      backgroundColor: "papaSmurf",
    };
  }

  if (isFlagEnabled(displayFlagsArray, "POPULAR_OFFER")) {
    return {
      status: "POPULAR_OFFER",
      description: "Popular Offer!",
      backgroundColor: "popularOffer",
    };
  }

  if (isFlagEnabled(displayFlagsArray, "NEW_TO_THE_FO")) {
    return {
      status: "NEW_TO_THE_FO",
      description: "New to the 'fo",
      backgroundColor: "newToTheFo",
    };
  }

  return undefined;
};
